import _ from 'lodash'

class PaymentManagementController {
  constructor(BillingService, Billing, AuthService, $sessionStorage, $scope) {
    this.BillingService = BillingService
    this.Billing = Billing
    this.AuthService = AuthService

    this.$storage = $sessionStorage
    this.$scope = $scope
    this.formattedBilling = {}

    // TODO: Remove this once updating billing info is enabled.
    // This is to disable the form and prevent changes.
    this.submitting = true
    this.hideAuthorizeButton = true
  }

  get billingInfo() {
    if (!this._billingInfo) {
      this._billingInfo = this.Billing.get(
        {userId: this.AuthService.currentUserId},
        this._onBillingInfoSuccess.bind(this)
      )
    }

    return this._billingInfo
  }

  _onBillingInfoSuccess(billingInfo) {
    this._billingInfo = _.mapKeys(
      billingInfo,
      (val, key) => {
        return key.match(/address/) ? key : _.snakeCase(key)
      }
    )
  }
}

PaymentManagementController.$inject = [
  'BillingService',
  'Billing',
  'AuthService',
  '$sessionStorage',
  '$scope'
]

export default PaymentManagementController
